import type { VideoModel } from '@/shared/generated'

export const ChatMessageArtifactCard = ({ video }: { video: VideoModel }) => (
	<div className='inline-flex cursor-pointer items-center gap-2 rounded-lg border bg-muted p-2 text-sm'>
		<div className='flex items-start gap-2'>
			<img
				src={video.thumbnail}
				alt='Image'
				className='h-20 w-36 rounded-md object-cover'
			/>
			<div className='flex flex-col gap-2'>
				<span className='text-base font-semibold'>{video.name}</span>
			</div>
		</div>
	</div>
)
